var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.allowed)?_c('div',{staticClass:"internal-container"},[_c('InternalHeader',{attrs:{"title":"Nutzerverwaltung","icon":"people"}}),_c('UserBatchActions'),_c('UserSearchAndManage'),_c('UserImport')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }